// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@mcmc/App/Store/Selectors/SettingsSelectors";
import { useScript } from "@mcmc/App/Widgets/ExternalScriptWidget/useScript";
import React from "react";
import { connect } from "react-redux";

type OwnProps = {
    sessionId: string;
};

const mapStateToProps = (state: ApplicationState) => {
    const customSettings = getSettingsCollection(state).customSettings;

    return {
        useKount: customSettings.useKount.toLowerCase() === "true",
        deviceDataCollectorApiUrl: customSettings.kountDeviceDataCollectorUrl,
        merchantID: customSettings.kountMerchantId,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const KountDeviceCollector: React.FC<Props> = ({
    children,
    useKount,
    deviceDataCollectorApiUrl,
    merchantID,
    sessionId,
}) => {
    const src =
        useKount && sessionId && deviceDataCollectorApiUrl && merchantID
            ? `${deviceDataCollectorApiUrl}?m=${merchantID}&s=${sessionId}&spa=true`
            : "";
    const status = useScript(src);

    React.useEffect(() => {
        if (status === "ready") {
            if ((window as any).ka) {
                const sdk = new (window as any).ka.ClientSDK();

                /* sdk.setupCallback({                     
                    // fires when collection has finished - this example would not enable the                     
                    // login button until collection has completed                     
                    "collect-end": function (params: any) {},                     
                    // fires when collection has started.                     
                    "collect-begin": function (params: any) {},
                }); */

                sdk.autoLoadEvents();
            }
        }
    }, [status]);
    return (
        <div className="kaxsdc" data-event="load">
            {children}
        </div>
    );
};

export default connect(mapStateToProps)(KountDeviceCollector);
